import React, { useEffect, useState } from "react"
import { Col, Modal, Label, FormGroup } from "reactstrap"
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
    commonPageFieldList,
    commonPageFieldListSuccess,
    DeleteRoleAcess,
    DeleteRoleAcessSuccess,
    EditRoleAcessAction,
    getRoleAccessListPage,
    getRoleAccessListPageSuccess,
    saveCopyRoleAccessActionSuccess,
    updateRoleAcessAction,
} from "../../../store/actions";
import { useHistory } from "react-router-dom";
import RoleAccessCopyFunctionality from "./RoleAccessCopyFunctionality";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";

import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url"
import { btnIsDissablefunc, isSuperAdmin, loginCompanyID } from "../../../components/Common/CommonFunction";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import RoleAccessAdd from "./RoleAccessAdd"
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { C_Button, Go_Button } from "../../../components/Common/CommonButton";
import { getcompanyList } from "../../../store/Administrator/CompanyRedux/actions";


const RoleAccessListPage = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [modal_center, setmodal_center] = useState(false);
    const [copy_user_RowData, setCopy_user_RowData] = useState({});
    const [company_dropdown_Select, setCompany_dropdown_Select] = useState({ label: "Select...", value: 0 });

    const isSuperAdminRole = !isSuperAdmin()

    const reducers = useSelector(
        (state) => ({
            tableList: state.RoleAccessReducer.RoleAccessListPage,
            userAccess: state.Login.RoleAccessUpdateData,
            postMsg: state.RoleAccessReducer.postMsg,
            postMsgCopy: state.RoleAccessReducer.postMsgCopy,
            deleteMsg: state.RoleAccessReducer.deleteMsg,
            editData: state.RoleAccessReducer.editData,
            updateMsg: state.RoleAccessReducer.updateMsg,
            pageField: state.CommonPageFieldReducer.pageFieldList,
            company: state.Company.companyList,

        })
    );

    const { postMsgCopy, company, pageField, userAccess = [], tableList } = reducers;
    

    const action = {
        getList: getRoleAccessListPage,
        editId: EditRoleAcessAction,
        deleteId: DeleteRoleAcess,
        postSucc: getRoleAccessListPageSuccess,
        updateSucc: updateRoleAcessAction,
        deleteSucc: DeleteRoleAcessSuccess
    }

    //  This UseEffect => Featch Modules List data  First Rendering
    useEffect(() => {
        const page_Id = pageId.ROLEACCESS_lIST
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(page_Id))
        if (isSuperAdminRole) {
            dispatch(getRoleAccessListPage());
        }
        dispatch(getcompanyList());
        return () => {
            dispatch(getRoleAccessListPageSuccess([]))
        }
    }, []);

    useEffect(() => {
        if ((postMsgCopy.Status === true) && (postMsgCopy.StatusCode === 200)) {
            dispatch(saveCopyRoleAccessActionSuccess({ Status: false }))
            if (isSuperAdminRole) {
                dispatch(getRoleAccessListPage());
            }
            tog_center()
            customAlert({
                Type: 1,
                Message: postMsgCopy.Message,
            })
        }
        else if (postMsgCopy.Status === true) {
            dispatch(saveCopyRoleAccessActionSuccess({ Status: false }))
            customAlert({
                Type: 1,
                Message: JSON.stringify(postMsgCopy.Message),
            })
        }
    }, [postMsgCopy])

    function editBodyfunc(config) {
        const { rowData } = config;

        if (rowData.Division_id === null) {
            rowData.Division_id = 0
        }
        history.push({
            pathname: url.ROLEACCESS,
            state: config,
        })
    }

    const CompanyValues = company.map((i) => ({
        value: i.id,
        label: i.Name
    }));
    async function deleteBodyfunc(config) {

        const { rowData, btnId } = config;

        const ispermission = await customAlert({
            Type: 7,
            Message: `${alertMessages.deleteOrNot} Role : "${rowData.RoleName}"`,
        })
        if (ispermission) {
            btnIsDissablefunc({ btnId, state: true })
            let role = rowData.Role_id
            let division = rowData.Division_id === null ? 0 : rowData.Division_id
            let company = rowData.Company_id
            dispatch(DeleteRoleAcess({ role, division, company, btnId }))
        }
    }

    function copyBodyfunc(config) {
        const { rowData, btnId } = config;
        setCopy_user_RowData(rowData)
        tog_center()
        btnIsDissablefunc({ btnId, state: false })
    }

    function goButnFunc() {
        if (company_dropdown_Select.value === 0) {
             customAlert({
                Type: 3,
                Message: "Please Select Company",
            })
            return
        }
        dispatch(getRoleAccessListPage({ loginCompanyID: company_dropdown_Select.value }));
    }
    // tag_center -- Control the Edit Modal show and close
    function tog_center() {
        setmodal_center(!modal_center)
    }



    const handleClearBtn = () => {
        setCompany_dropdown_Select({ label: "Select...", value: 0 })
        dispatch(getRoleAccessListPageSuccess([]))
    };

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: "-4px" }}>
                <>
                    {!isSuperAdminRole && <div className="px-2   c_card_filter text-black" >
                        <div className="row" >


                            <Col sm="4" className="">
                                <FormGroup className=" row mt-2 " >
                                    <Label className="col-sm-5 p-2"
                                        style={{ width: "65px" }}>Company</Label>
                                    <Col sm="7">
                                        <Select
                                            value={company_dropdown_Select}
                                            className="rounded-bottom"
                                            placeholder="Select..."
                                            isDisabled={(company_dropdown_Select.value > 0 && tableList.length > 0)}
                                            options={CompanyValues}
                                            onChange={(e) => { setCompany_dropdown_Select(e) }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>

                            <Col sm="7" ></Col>



                            <Col sm="1" className="mt-2 mb-2 ">

                                {
                                    (!(company_dropdown_Select.value > 0 && tableList.length > 0)) ?
                                        <C_Button
                                            type="button"
                                            style={{ margin: "3px" }}
                                            className="btn btn-primary border-1 font-size-12 text-center ml-1"
                                            onClick={() => { goButnFunc() }}
                                        >
                                            Select
                                        </C_Button>
                                        :
                                        <C_Button
                                            type="button"
                                            style={{ margin: "3px" }}
                                            className="btn btn-success border-1 font-size-12 text-center ml-1"
                                            onClick={handleClearBtn}
                                        >
                                            Change
                                        </C_Button>
                                }
                            </Col>


                        </div>
                    </div>}
                </>
                {
                    (pageField) ?
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            showBreadcrumb={false}
                            newBtnPath={url.ROLEACCESS}
                            MasterModal={RoleAccessAdd}
                            editBodyfunc={editBodyfunc}
                            copyBodyfunc={copyBodyfunc}
                            goButnFunc={goButnFunc}
                            deleteBodyfunc={deleteBodyfunc}
                            masterPath={url.ROLEACCESS}
                            ButtonMsgLable={"RoleAccess"}
                            deleteName={"Name"}
                        />
                        : null
                }
            </div>
            <Modal
                isOpen={modal_center}
                toggle={() => { tog_center() }}
                size="xl"
            >
                <RoleAccessCopyFunctionality state={copy_user_RowData} />

            </Modal>
        </React.Fragment>
    )
}

export default RoleAccessListPage
